export default "__VITE_ASSET__BtQ7hqzS__"